module.exports = __webpack_public_path__ + "static/media/OrderDispatched.16fa0525.gif";